import { Routes } from '../constant/Routes';

export const QuickLinks = [
	{
		link: Routes.Home,
		title: 'Home',
	},
	{
		link: Routes.Projects,
		title: 'Projects',
	},
];
